
const PortfolioSection = () => {
  const portfolioItems = [
    {
      title: '大手製造業の企業年金運用',
      category: '機関投資家向けサービス',
      description: '従業員5,000名規模の製造業企業の企業年金基金運用を担当。安定的なリターンと適切なリスク管理により、年平均6.2%の運用成績を達成。',
      image: 'https://public.readdy.ai/ai/img_res/2b3025cd51ad18122ef94433851cbc3e.jpg',
      results: ['年平均リターン: 6.2%', '運用期間: 8年', '資産規模: ¥50億']
    },
    {
      title: '富裕層ファミリーの資産継承',
      category: 'ウェルスマネジメント',
      description: '3世代にわたる資産継承プランを策定。税務効率を最大化しながら、事業承継と個人資産の最適化を実現。',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20family%20business%20office%2C%20wealth%20management%20consultation%2C%20traditional%20meets%20modern%20design%2C%20professional%20advisory%20meeting%2C%20sophisticated%20interior%2C%20family%20legacy%20planning&width=400&height=300&seq=portfolio-2&orientation=landscape',
      results: ['節税効果: 30%改善', '資産継承完了', '事業価値向上: 40%']
    },
    {
      title: 'スタートアップ企業のIPO準備',
      category: 'コーポレートファイナンス',
      description: 'テクノロジー系スタートアップ企業のIPO準備段階から上場後の資金調達まで包括的にサポート。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20startup%20office%2C%20IPO%20preparation%20meeting%2C%20technology%20company%2C%20young%20entrepreneurs%2C%20innovative%20workspace%2C%20financial%20planning%20session%2C%20bright%20modern%20interior&width=400&height=300&seq=portfolio-3&orientation=landscape',
      results: ['IPO成功', '調達額: ¥15億', '株価上昇: 150%']
    },
    {
      title: '個人投資家の退職金運用',
      category: '個人向け資産運用',
      description: '退職金2,000万円の運用を通じて、安定した老後生活資金の確保と資産の目減り防止を実現。',
      image: 'https://readdy.ai/api/search-image?query=Comfortable%20Japanese%20retirement%20planning%20consultation%2C%20senior%20couple%20meeting%20with%20financial%20advisor%2C%20warm%20office%20environment%2C%20retirement%20lifestyle%20planning%2C%20professional%20guidance&width=400&height=300&seq=portfolio-4&orientation=landscape',
      results: ['年平均リターン: 4.8%', '運用期間: 5年', 'リスク軽減: 25%']
    },
    {
      title: '不動産投資ファンドの組成',
      category: 'オルタナティブ投資',
      description: '東京都心部の商業用不動産を対象とした投資ファンドを組成。機関投資家から個人投資家まで幅広く参加。',
      image: 'https://readdy.ai/api/search-image?query=Premium%20Tokyo%20commercial%20real%20estate%2C%20modern%20office%20buildings%2C%20urban%20investment%20properties%2C%20professional%20real%20estate%20fund%20management%2C%20city%20skyline%2C%20business%20district&width=400&height=300&seq=portfolio-5&orientation=landscape',
      results: ['ファンド規模: ¥80億', '投資家数: 120名', '年間配当: 5.5%']
    },
    {
      title: 'ESG投資ポートフォリオ',
      category: '持続可能投資',
      description: '環境・社会・ガバナンスを重視したESG投資ポートフォリオの構築により、社会的責任と収益性を両立。',
      image: 'https://readdy.ai/api/search-image?query=Sustainable%20ESG%20investment%20concept%2C%20green%20technology%20companies%2C%20renewable%20energy%20projects%2C%20environmental%20responsibility%2C%20modern%20sustainable%20business%20practices%2C%20clean%20energy%20infrastructure&width=400&height=300&seq=portfolio-6&orientation=landscape',
      results: ['ESGスコア: A+', '年平均リターン: 7.1%', 'CO2削減貢献: 500t']
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            成功事例と<span className="text-blue-600">実績</span>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            多様なクライアントとの協働により築き上げた実績をご紹介します。
            それぞれの成功事例が、私たちの専門性と信頼性を物語っています。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioItems.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="relative overflow-hidden">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {item.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h4 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h4>
                <p className="text-gray-600 mb-4 leading-relaxed text-sm">{item.description}</p>
                
                <div className="space-y-2 mb-4">
                  {item.results.map((result, resultIndex) => (
                    <div key={resultIndex} className="flex items-center text-sm">
                      <i className="ri-check-double-line text-green-500 mr-2"></i>
                      <span className="text-gray-700">{result}</span>
                    </div>
                  ))}
                </div>
                
                <div className="pt-4 border-t border-gray-100">
                  <a 
                    href="#contact" 
                    className="text-blue-600 hover:text-blue-700 font-medium flex items-center gap-2 group-hover:gap-3 transition-all text-sm"
                  >
                    詳細を相談する
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
